import { useMutation } from '@tanstack/react-query'
import { putSubmitCryptoMassPayoutById } from 'services/MasspayoutService'

export const usePutSubmitCryptoMassPayoutMutation = () => {
  return useMutation({ mutationFn: putSubmitCryptoMassPayoutById })
}
